var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"printer"},[_c('h6',[_vm._v(" "+_vm._s(_vm.printer.name)+" ")]),_c('div',{staticClass:"edit-delete"},[_vm._t("edit-delete")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }